import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
// qrcode
import Qreader from "react-qr-reader";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// service
import { getParticipantsId, createReading } from "../../services/ache";

export default function AcheGds() {
  // parametros
  const [searchParams] = useSearchParams();
  // usuario
  const [user, setUser] = useState(null);
  // erros
  const [errors, setErrors] = useState("");
  // leitor
  const [scan, setScan] = useState(false);
  // carregamento
  const [loading, setLoading] = useState(false);
  //   alerta
  const [alertSuccess, setAlertSuccess] = useState(false);
  const [alertError, setAlertError] = useState("");
  // id do evento
  //   const idEvent = "94eb6efb-fc61-4897-a153-c7597c8a73f5";
  const idEvent = "3f4a980e-5150-47e9-aac1-9f0ec73319fd";

  async function readScan(e) {
    setLoading(true);

    try {
      const res = await getParticipantsId(e, idEvent);
      // console.log("res", res);

      if (res?.data?.id) {
        const dataApi = {
          eventId: idEvent,
          readerId: user.idPart,
          targetId: res.data.id,
          description: user.pgm,
        };

        const resPost = await createReading(dataApi);
        // console.log("resPost", resPost);

        if (resPost.message === "CREATED") {
          setAlertSuccess(true);
          setScan(false);
        } else if (resPost.message === "ALREADY_EXISTS") {
          setAlertError("Esse QRCode já foi lido!");
        }
      } else setAlertError("Usuário não encontrado");
    } catch (error) {
      // console.log("erro get", error);
      setAlertError("Erro ao processar dados");
    } finally {
      setLoading(false);
    }
  }

  function changeScan() {
    setScan(!scan);
    setLoading(false);
  }

  useEffect(() => {
    if (window.location.search !== "") {
      const idPart = searchParams.get("idPart");
      const pgm = searchParams.get("pgm");

      setUser({
        idPart,
        pgm,
      });
    } else setErrors("Erro ao ler participante e/ou programação");
  }, []);
  return (
    <>
      {alertSuccess && (
        <SweetAlert
          title="Sucesso"
          success
          onConfirm={() => {
            setAlertSuccess(false);
            changeScan();
          }}
        >
          QRCode lido com sucesso !
        </SweetAlert>
      )}

      {alertError && (
        <SweetAlert
          title="Erro"
          error
          onConfirm={() => {
            setAlertError("");
            changeScan();
          }}
        >
          {alertError}
        </SweetAlert>
      )}

      <div
        className="div-general-qrcode"
        style={{ backgroundColor: "#d9166d" }}
      >
        {errors ? (
          <div className="div-error">
            <h4>{errors}</h4>
          </div>
        ) : (
          <>
            {scan && (
              <div style={{ width: 350 }}>
                <Qreader
                  onScan={(e) => {
                    if (e && scan && !loading) {
                      readScan(e);
                    }
                  }}
                  onError={(e) => console.log("erro reader", e)}
                  className="qrcode-scan"
                />
              </div>
            )}

            {scan ? (
              <a
                className="action-reader open-reader"
                style={{ backgroundColor: "red" }}
                onClick={() => changeScan()}
              >
                Fechar Scan
              </a>
            ) : (
              <a
                className="action-reader open-reader"
                style={{ backgroundColor: "white", color: "#d9166d" }}
                onClick={() => changeScan()}
              >
                Ler QRCode
              </a>
            )}
          </>
        )}
      </div>
    </>
  );
}
